export default __webpack_public_path__ + "static/media/ondemand-upgrade.6d5f1659.png";